import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";
import { QueryBuilder } from "../utils/queryBuilder";

export const getMemberJournals = ({ churchId, memberId, queries }) => {
  const queryBuilder = new QueryBuilder();

  if (queries?.filter) {
    queryBuilder.filter(queries.filter);
  }

  if (queries?.search) {
    queryBuilder.search(queries.search);
  }

  if (queries?.sort) {
    queryBuilder.sort(queries.sort);
  }

  const queryString = queryBuilder.build();

  return axios.get(
    `/churches/${churchId}/member-journals/${memberId}${queryString}`
  );
};

export const useMemberJournals = ({
  churchId,
  memberId,
  queries,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["member-journals", churchId, memberId, JSON.stringify(queries)],
    queryFn: () => getMemberJournals({ churchId, memberId, queries }),
    select: data => data.result
  });
};
